<template>
  <div>
    <el-dialog v-if="xqVisible" :close-on-click-modal="false" title="订单详情" width="80%" :visible.sync="xqVisible"
               :before-close="closeEvent">
      <div class="turnoverTab" style="overflow:scroll;">
        <div class="t-member" style="margin-bottom: 25px">
          <span class="t-span">客户名称: {{order.memberName==null?'散客':order.memberName}} {{order.cardName==null?'':'('+order.cardName+')'}}</span>
          <span class="t-span" v-if="order.phone">客户手机: {{order.phone}}</span>
          <span class="t-span">门店名称: {{order.kdName==null?deptName:order.kdName}}</span>
          <span class="t-span">订单标识:
            <el-tag v-if="order.orderBs==1" size="mini" type="warning" >普通</el-tag>
            <el-tag v-if="order.orderBs==2" size="mini">记时</el-tag>
          </span>
          <span class="t-span">消费时间: {{order.createTime}}</span>
          <span class="t-span">服务时间: {{order.endTime}}</span>
        </div>
        <div class="t-list">
          <div class="t-xf">
            <span>消费信息</span>
          </div>
          <div style="width:98%;margin: auto;margin-top: 18px;">
            <table
              cellspacing="0"
              border="0"
              width="100%"
              style="text-align: center"
            >
              <thead>
              <tr style="background-color: #F7F7F7;border:#EEEEEE solid 1px;">
                <th class="tab-th">名称</th>
                <th class="tab-th">单价</th>
                <th class="tab-th">数量</th>
                <th class="tab-th" v-if="checkPermission('lsAddEmp')">添加员工</th>
                <th class="tab-th">员工</th>
                <th class="tab-th">是否指定</th>
                <th class="tab-th">业绩</th>
                <th class="tab-th">提成</th>
                <th class="tab-th">分段提成</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in orderInfos">
                <td class="t-td-l" style="border-left:#EEEEEE solid 1px;">
                  {{item.commodityName}}
                </td>
                <td class="t-td-l">{{item.price}}</td>
                <td class="t-td-l">1</td>
                <td class="t-td-l" v-if="checkPermission('lsAddEmp')">
              <span style="cursor: pointer;width: 15px;display: inline-block; font-size: 18px;"
                    @click="addEmp(item.id)">
                +
              </span>
                </td>
                <td class="t-td-l">
                  <table style="width:100%;">
                    <tr v-if="item.empAcs.length>0" v-for="(ac,i) in item.empAcs">
                      <td class="empac" :class="{empac1:i==0}">{{ac.empName}}<span
                        style="font-size: 8px;color: #ff4d51"> ({{ac.sxName}})</span>
                        <span v-if="checkPermission('lsDelEmp')"
                              style="margin-left: 8px;cursor: pointer;color: #ff4d51;font-size: 8px;;float: right;padding-right: 12px"
                              @click="toDel(ac)">删除</span>
                      </td>
                    </tr>
                    <tr v-if="item.empAcs.length==0">
                      <td class="empac1">暂无</td>
                    </tr>
                  </table>
                </td>
                <td class="t-td-l">
                  <table style="width:100%;">
                    <tr v-if="item.empAcs.length>0" v-for="(ac,i) in item.empAcs">
                      <td class="empac" :class="{empac1:i==0}">
                        <span v-if="ac.appoint==1">非指定</span>
                        <span v-if="ac.appoint==2">指定</span>
                      </td>
                    </tr>
                    <tr v-if="item.empAcs.length==0">
                      <td class="empac">暂无</td>
                    </tr>
                  </table>
                </td>
                <td class="t-td-l">
                  <table style="width:100%">
                    <tr v-if="item.empAcs.length>0" v-for="(ac,i) in item.empAcs">
                      <td class="empac" :class="{empac1:i==0}">{{ac.ach}}</td>
                    </tr>
                    <tr v-if="item.empAcs.length==0">
                      <td class="empac">暂无</td>
                    </tr>
                  </table>
                </td>
                <td class="t-td-l">
                  <table style="width:100%">
                    <tr v-if="item.empAcs.length>0" v-for="(ac,i) in item.empAcs">
                      <td class="empac" :class="{empac1:i==0}">{{ac.cmn}}</td>
                    </tr>
                    <tr v-if="item.empAcs.length==0">
                      <td class="empac">暂无</td>
                    </tr>
                  </table>
                </td>
                <td class="t-td-l">
                  <table style="width:100%">
                    <tr v-if="item.empAcs.length>0" v-for="(ac,i) in item.empAcs">
                      <td class="empac" :class="{empac1:i==0}">{{ac.fdCmn}}</td>
                    </tr>
                    <tr v-if="item.empAcs.length==0">
                      <td class="empac">暂无</td>
                    </tr>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="l-list" v-if="order.isFw">
          <div class="t-xf">
            <span>服务商品</span>
          </div>
          <div style="width:98%;margin: auto;margin-top: 18px;display: flex;flex-direction: column">
            <div v-for="item in orderInfos" style="margin-bottom: 5px" v-if="item.specNo||item.spec">
              <span class="nnnn">编号:{{item.specNo}}</span> <span class="nnnn1">规格:{{item.spec}}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 添加员工框 -->
    <el-dialog title="添加员工" :visible.sync="empVisible" width="450px" center>
      <el-form ref="form" size="small" label-width="90px">
        <el-form-item label="岗位" prop="adName">
          <el-select v-model="plabsId" placeholder="请选择岗位" size="small" style="width: 280px;"
                     @change="getEmpList(plabsId)">
            <el-option
              v-for="item in plabsList"
              :key="item.id"
              :label="item.paAttribute"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工" prop="adName">
          <el-select v-model="empId" placeholder="请选择员工" size="small" style="width: 280px;" @change="setEmp(empId)">
            <el-option
              v-for="item in empList"
              :key="item.id"
              :label="item.nickName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方式" prop="appoint">
          <el-radio-group v-model="appoint">
            <el-radio :label="1">非指定</el-radio>
            <el-radio :label="2">指定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="业绩" prop="adName">
          <el-input-number
            v-model="ach"
            auto-complete="off"
            :precision="2"
            :controls="false"
            maxlength="6"
            style="width: 280px;"
          />
        </el-form-item>
        <el-form-item label="类型" prop="appoint">
          <el-radio-group v-model="cmnType">
            <el-radio :label="1">比例</el-radio>
            <el-radio :label="2">固定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提成" prop="adName">
          <el-input-number
            v-model="cmnVal"
            auto-complete="off"
            :precision="2"
            :controls="false"
            maxlength="6"
            style="width: 280px;"
          />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="empVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveEmp">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="acDel" width="300px" center>
      <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="acDel = false">取 消</el-button>
        <el-button size="small" type="primary" @click="delAc">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {getSwName,getToken} from "../../utils/auth";
  import {checkPermission} from "../../utils/main";

  export default {
    name: "xq",
    data() {
      return {
        deptName: getSwName(),
        orderId: '',
        orderInfoId: '',
        ach: 0,
        cmnType:1,
        cmnVal:0,
        order: {},
        orderInfos: [],
        empVisible: false,

        acId: '',
        acDel: false,

        plabsList: [],
        plabsId: '',
        empList: [],
        empId: '',

        form: {},
        appoint: 1,
      };
    },
    async created() {
      this.orderId = this.id
      this.getOrderInfo()
      this.getPlabsList()
    },
    props: {
      xqVisible: Boolean,
      id: String
    },
    methods: {
      checkPermission,
      closeEvent() {
        this.$emit("closeXQ")
      },
      toDel(item) {
        this.acId = item.id
        this.acDel = true
      },

      async getOrderInfo() {
        let res = await this.$get("/sw/getSwOrderDetails", {orderId: this.orderId});
        this.order = res.order
        this.orderInfos = res.syOrderInfos
      },
      //获取岗位信息
      async getPlabsList() {
        let res = await this.$get("/sw/getSwPlabsList", {token: getToken()});
        this.plabsList = res.plabsList
      },
      //获取员工信息
      async getEmpList(plabsId) {
        let plabs = this.plabsList.find(item => {
          if (item.id == plabsId) {
            return item
          }
        })
        let data = {
          deptId: plabs.deptId
        }
        if (plabs.station == 1) {
          data.firstStation = plabs.id
        }
        if (plabs.station == 2) {
          data.secondStation = plabs.id
        }
        if (plabs.station == 3) {
          data.thirdStation = plabs.id
        }
        this.station = plabs.station
        let res = await this.$get("/sw/getEmpList", data);
        this.empList = res.empList
      },

      async setEmp(empId) {
        let emp = this.empList.find(item => {
          if (item.id == empId) {
            return item
          }
        })
        let gradeId = ''
        if (this.station == 1) {
          gradeId = emp.firstLevel
        }
        if (this.station == 2) {
          gradeId = emp.secondLevel
        }
        if (this.station == 3) {
          gradeId = emp.thirdLevel
        }
        this.form = {
          orderInfoId: this.orderInfoId,
          employeeId: emp.id,
          appoint: this.appoint,
          station: this.station,
          gradeId: gradeId,
        }
      },

      addEmp(orderInfoId) {
        this.form = {}
        this.empVisible = true
        this.orderInfoId = orderInfoId
        this.plabsId = ''
        this.empId = ''
        this.ach = 0
        this.cmnType = 1
        this.cmnVal = 0
      },
      async saveEmp() {
        this.form.ach = this.ach
        this.form.cmnType = this.cmnType
        this.form.cmnVal = this.cmnVal
        let res = await this.$post("/sw/saveSwEmpAc", this.form);
        if (res.code == 200) {
          this.empVisible = false
          this.getOrderInfo()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      },
      async delAc() {
        let res = await this.$post("/sw/delSwEmpAc", {id: this.acId});
        if (res.code == 200) {
          this.acDel = false
          this.getOrderInfo()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      },
    },
    components: {},
  };
</script>


<style lang="scss" scoped>

  .turnoverTab {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 500px;
    overflow: auto;
  }

  .t-member {
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
  }

  .t-span {
    width: 100%;
    height: 28px;
    line-height: 28px;
    margin-left: 55px;
  }

  .t-list {
    display: flex;
    flex-direction: column;
    overflow: scroll;
  }

  .l-list {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .t-xf {
    height: 28px;
    line-height: 28px;
    background-color: #F7F7F7;
    padding-left: 20px;
  }

  .t-xf span {
    border-left: #2b94ff solid 2px;
    padding-left: 5px;
    font-weight: bold;
  }

  .tab-th {
    width: 10%;
    height: 38px;
    line-height: 38px;
    font-weight: bold;
  }

  .table-responsive {
    border: 2px solid rgb(40, 40, 40, .5);
    color: rgb(40, 40, 40);
  }

  .t-td-l {
    padding: 0;
    height: 30px;
    line-height: 30px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    border-right: #EEEEEE solid 1px;
    border-bottom: #EEEEEE solid 1px;
    font-size: 13px;
  }

  .empac {
    border-top: #EEEEEE solid 1px;
    height: 30px;
  }

  .empac1 {
    border-top: #EEEEEE solid 0px;
  }

  .nnnn {
    display: inline-block;
    width: 150px;
  }

  .nnnn1 {
    display: inline-block;
    width: 300px;
  }
</style>
